import { z } from "zod";

export const fetchSingleVehicleTripsPayloadSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  vehicleUuid: z.uuid(),
  isSendingNotification: z.boolean().optional(),
});

export type FetchSingleVehicleTripsPayload = z.infer<
  typeof fetchSingleVehicleTripsPayloadSchema
>;
